export default "__VITE_ASSET__CeovqHkH__"